import { Col, Row } from 'react-bootstrap';
import RadioInput from '../common/radio';

const OTP = ({ values, setFieldValue }) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>One‑Time Password</h3>
        <p>
          Select whether a One-Time Password is required to unlock the account.
        </p>
      </Col>
      <Col md={2} lg={2} sm={2} className="setup-form">
        <Row className="pt-2">
          <Col>
            <RadioInput
              id="otp-required"
              label="Yes"
              name="otp"
              value={true}
              checked={values.otp === true}
              onChange={(e) => {
                setFieldValue('otp', true);
              }}
            />
          </Col>
          <Col className="approval-enroll">
            <RadioInput
              id="otp-not-required"
              label="No"
              name="otp"
              value={false}
              checked={values.otp === false}
              onChange={(e) => {
                setFieldValue('otp', false);
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default OTP;
